import gql from 'graphql-tag';

const ANSWER_MATRIX = gql`
mutation answerMatrix($tester:ID!, $question:ID!, $answer: [[ID!]!]!){
    answerMatrixQuestion(participantId: $tester, campaignQuestionId: $question, answer: $answer)
  }
`;

export default ANSWER_MATRIX;
